export default __webpack_public_path__ + "static/media/vibraphone.49f33358.mp3";